import React from 'react'
import { EntryCardProps } from './types.d'
import Image from '@toasttab/shared/src/components/atoms/Image/Image'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import TextLink from '@toasttab/shared/src/components/molecules/TextLink/TextLink'
import { Icon } from '@toasttab/shared/src/utils/craftUtils'

const EntryCard = ({
  ctaLabel,
  ctaLink,
  image,
  linkIcons = 'none',
  sectionDescription,
  sectionHeading
}: EntryCardProps) => {
  return (
    <div
      className='overflow-hidden rounded-md border border-dark bg-white flex flex-col items-stretch'
      data-testid='entry-card'
    >
      <div className='mb-3 md:mb-2'>
        <Image {...image[0]} />
      </div>
      <div className='px-6'>
        <Typography variation='h5' as='h5' classes='mb-2 tracking-[0.2px]'>
          {sectionHeading}
        </Typography>
        <Typography variation='default' as='p' classes='text-secondary'>
          {sectionDescription}
        </Typography>
      </div>
      {ctaLabel && ctaLink && (
        <p className='mt-auto mb-6 px-6'>
          <TextLink
            href={ctaLink}
            text={ctaLabel}
            icon={Icon.linkIcons(linkIcons)}
          />
        </p>
      )}
    </div>
  )
}

export default EntryCard
